import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Text } from '@chakra-ui/react';
import { useCustomLocale, useLocalStorage } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { DISTANCE_FROM_SEARCH_INITIAL_VALUE, SEARCH_REFERRER_INITIAL_VALUE } from '../../search/constants';
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HotelLocation() {
  var _distanceFromSRPSearc, _searchReferrer$data;
  var _useLocalStorage = useLocalStorage('DistanceFromSearch', DISTANCE_FROM_SEARCH_INITIAL_VALUE),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 1),
    distanceFromSRPSearch = _useLocalStorage2[0];
  var _useLocalStorage3 = useLocalStorage('SearchReferrer', SEARCH_REFERRER_INITIAL_VALUE),
    _useLocalStorage4 = _slicedToArray(_useLocalStorage3, 1),
    searchReferrer = _useLocalStorage4[0];
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var distanceFromSearch = distanceFromSRPSearch === null || distanceFromSRPSearch === void 0 || (_distanceFromSRPSearc = distanceFromSRPSearch.data) === null || _distanceFromSRPSearc === void 0 ? void 0 : _distanceFromSRPSearc.distance;
  var referrer = searchReferrer === null || searchReferrer === void 0 || (_searchReferrer$data = searchReferrer.data) === null || _searchReferrer$data === void 0 ? void 0 : _searchReferrer$data.referrer;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!isMounted || !distanceFromSearch || Number.isNaN(Number(distanceFromSearch)) || !(referrer !== null && referrer !== void 0 && referrer.includes('search.html'))) {
    return null;
  }
  return _jsxs(Text, {
    "data-testid": "hdp_hotelDistanceFromSearch",
    children: [_jsxs("strong", {
      children: [Math.round(Number(distanceFromSearch) * 10) / 10, " ", language === 'en' ? 'miles' : 'km']
    }), " ".concat(t('searchresults.list.hotel.fromSearch'))]
  });
}